import React from "react";
import { EdButtonIcon } from "../../../components/generic/edbutton/edButton";
const DpTransactionDesk = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("table", { className: "table", cellSpacing: "0" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { className: "date" }, "Date"),
                    React.createElement("th", { className: "report-form" }, "Report From"),
                    React.createElement("th", { className: "report-to" }, "Report To"),
                    React.createElement("th", { className: "dp-id" }, "DP ID"),
                    React.createElement("th", { className: "status" }, "Status"),
                    React.createElement("th", null))),
            React.createElement("tbody", null, props.dpTranactions &&
                props.dpTranactions.length > 0 &&
                props.dpTranactions.map((dpTransactionRecord) => {
                    return (React.createElement("tr", null,
                        React.createElement("td", null, dpTransactionRecord.requestDate),
                        React.createElement("td", null, dpTransactionRecord.reportFromDate),
                        React.createElement("td", null, dpTransactionRecord.reportToDate),
                        React.createElement("td", null, dpTransactionRecord.dpID),
                        React.createElement("td", null,
                            React.createElement("span", { className: dpTransactionRecord.requestStatus === "Open"
                                    ? "st-open"
                                    : "st-closed" }, dpTransactionRecord.requestStatus)),
                        React.createElement("td", null,
                            React.createElement(EdButtonIcon, { btnTyp: "light-navy", disabled: dpTransactionRecord.requestStatus !== "Open"
                                    ? false
                                    : true, className: "download-btn", btnIcon: "edel-icon-bold-download", onClick: () => {
                                    props.sendEmailReport({
                                        dpTransactionRecord,
                                        email: false,
                                    });
                                } }),
                            React.createElement(EdButtonIcon, { btnTyp: "light-navy", className: "msg-btn", btnIcon: "edel-icon-msg", disabled: dpTransactionRecord.requestStatus !== "Open"
                                    ? false
                                    : true, onClick: () => {
                                    props.sendEmailReport({
                                        dpTransactionRecord,
                                        email: true,
                                    });
                                } }))));
                })))));
};
export default DpTransactionDesk;
